import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { MyDatePickerModule } from 'mydatepicker';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

import { AdminUtilityRoutingModule } from './admin-utility-routing.module';
import { AdminUtilityComponent } from './admin-utility/admin-utility.component';
// import { HgEnergyProvidersUtilityInfoComponent } from './hg-energy-providers-utility-info/hg-energy-providers-utility-info.component';
import { EnergyProvidersModalComponent } from './energy-providers-modal/energy-providers-modal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { EnergyProvidersTduRatesModalComponent } from './energy-providers-tdu-rates-modal/energy-providers-tdu-rates-modal.component';
import { MatSelectModule } from '@angular/material/select';
// import { AdminUtilityReportComponent } from './admin-utility-report/admin-utility-report.component';
import { AdminUtilitiesComponent } from './admin-utilities/admin-utilities.component';
import { MatTableModule } from '@angular/material/table';
import { AdminUtilityReportModalComponent } from './admin-utility-report-modal/admin-utility-report-modal.component';
import { AdminValidationModalComponent } from './admin-validation-modal/admin-validation-modal.component';
import { AdminUtilityLoginComponent } from './admin-utility-login/admin-utility-login.component';
// import { DatepickerComponent } from '../questionarie-signup/datepicker/datepicker.component';
import { CommonHeaderComponent } from '../common-header/common-header.component';
import { CommonHeaderModule } from '../common-header/common-header.module';
import { LoginModule } from './../login/login.module';
import { PrePaidModalComponent } from './pre-paid-modal/pre-paid-modal.component';
import { AdminAffiliationComponent } from './admin-affiliation/admin-affiliation.component';
import { AdminZipcodeComponent } from './admin-zipcode/admin-zipcode.component';
import { AdminPromoCodeComponent } from './admin-promocode/admin-promocode.component';
import { NgSelectModule } from '@ng-select/ng-select';
// import { AdminAffiliationListComponent } from './admin-affiliation-list/admin-affiliation-list.component';

@NgModule({
  entryComponents: [
    EnergyProvidersModalComponent,
    EnergyProvidersTduRatesModalComponent,
    AdminUtilityReportModalComponent,
    AdminValidationModalComponent,
    PrePaidModalComponent,
    AdminAffiliationComponent,
    // AdminAffiliationListComponent
  ],
  imports: [
    CommonModule,
    AdminUtilityRoutingModule,
    FormsModule,
    NgxPaginationModule,
    MyDatePickerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatTableModule,
    BrowserModule,
    CommonHeaderModule,
    LoginModule,
    NgSelectModule,
  ],
  declarations: [
    AdminUtilityComponent,
    // HgEnergyProvidersUtilityInfoComponent,
    //HgEnergyProvidersTduRatesComponent,
    EnergyProvidersModalComponent,
    EnergyProvidersTduRatesModalComponent,
    // AdminUtilityReportComponent,
    AdminUtilitiesComponent,
    AdminUtilityReportModalComponent,
    AdminValidationModalComponent,
    AdminUtilityLoginComponent,
    PrePaidModalComponent,
    // CommonHeaderComponent,
    // DatepickerComponent,
      AdminAffiliationComponent,
      AdminPromoCodeComponent,
      AdminZipcodeComponent
    // AdminAffiliationListComponent
  ],
  providers: [DatePipe],
})
export class AdminUtilityModule {}
